import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const RepresentationRightsCheckingView = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        px: 2,
        py: 4
      }}
    >
      <CircularProgress />
      <Typography align="center">{t('checking-representation-rights')}</Typography>
    </Box>
  )
}

export default RepresentationRightsCheckingView
